import React, {Component} from 'react';
import {Navbar, Nav, NavItem, NavDropdown, MenuItem} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {LinkContainer} from 'react-router-bootstrap';
import style from './style.less';
import './style.less';

export default class Header extends Component {
	render() {
		return (
			<Nav className={style.ulcustom}>
				<LinkContainer to="#">
					<NavItem eventKey={1} href="#">
						<b>HOME</b>
					</NavItem>
				</LinkContainer>
				<LinkContainer to="#">
					<NavItem eventKey={2} href="#">
						<b>SHOP</b>
					</NavItem>
				</LinkContainer>
				<LinkContainer to="#">
					<NavItem eventKey={3} href="#">
						<b>MEN</b>
					</NavItem>
				</LinkContainer>
				<LinkContainer to="#">
					<NavItem eventKey={4} href="#">
						<b>WOMEN</b>
					</NavItem>
				</LinkContainer>
				<LinkContainer to="#">
					<NavItem eventKey={5} href="#">
						<b>KIDS</b>
					</NavItem>
				</LinkContainer>
				<LinkContainer to="#">
					<NavItem eventKey={6} href="#">
						<b>NEW ARRIVAL</b>
					</NavItem>
				</LinkContainer>
				<LinkContainer to="#">
					<NavItem eventKey={7} href="#">
						<b>SALE</b>
					</NavItem>
				</LinkContainer>
			</Nav>
		);
	}
}



// WEBPACK FOOTER //
// ./components/header/Navigation.js